









































































































import {
  Component,
  Prop,
  Vue,
  Watch,
  Mixins,
  ProvideReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  // ProductChildren,
  channelAttributeParse,
  channelAttrImages,
  specialChannel
} from "@root/lib/mixins";
import { FormVaildateToOut } from "@root/lib/decorator";
import channelAttrItem from "@/components/pages/ProductCreate/channelComponents/channelAttrItem.vue";
import channelSkuMediaDialog from "@/components/pages/ProductCreate/channelComponents/channelSkuMediaDialog.vue";
const Root = namespace("root");
@Component({
  name: "channelAttributeBLock",
  components: { channelAttrItem, channelSkuMediaDialog }
})
@FormVaildateToOut("form", {
  resCbName: "resFormart"
})
export default class channelAttributeBLock extends Mixins(
  // ProductChildren,
  channelAttributeParse,
  channelAttrImages,
  specialChannel
) {
  @Prop({ default: "" }) channelProductCode;
  @Prop({ default: "" }) labelPosition;
  @Prop({ type: Boolean, default: true }) isReturn;
  @Prop({ type: Function, required: false }) vaildateRegister;
  @Prop({ type: Function, required: false }) vaildateRemove;
  @Prop({ type: Number, required: false, default: 1 }) level;
  @Prop({ default: false }) readonly;
  mounted() {
    // register vaildte function
    this.vaildateRegister(this.blockValidate);
  }
  beforeDestroy() {
    this.vaildateRemove(this.blockValidate);
  }
  async blockValidate() {
    return new Promise(async (resolve, reject) => {
      // console.log(this.isReturn, this.level);

      console.log(
        this.isReturn,
        this.level,
        this.blockList.map(_ => _.channelAttrName).join("~~")
      );
      if (!this.isReturn) {
        // console.log("novalidate");
        // console.log(JSON.stringify(this.ruleForm, null, 4));

        resolve([]);
      } else {
        let res = await (this as any).handleVaildate();
        resolve(res);
      }
    });
  }
}
